import React from 'react';

import 'antd/dist/antd.css';

import ParamsProvider from './providers/ParamsProvider'
import FirebaseProvider from './providers/FirebaseProvider'
import RouterProvider from './providers/RouterProvider'
import UploadProvider from './providers/UploadProvider';

function App() {
  return (
    <ParamsProvider>
      <FirebaseProvider>
        <UploadProvider>
          <RouterProvider /> 
        </UploadProvider>
      </FirebaseProvider> 
    </ParamsProvider> 
  );
}

export default App;
